import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'VWidget',
  props: {
    page: { type: Boolean, default: false },
    space: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
    secondary: { type: Boolean, default: false },
},
  setup(__props) {

// Other
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["widget", {
            'widget--page': props.page,
            'widget--space': props.space,
            'widget--primary': props.primary,
            'widget--secondary': props.secondary,
        }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})